import React from 'react';
import { observer } from 'mobx-react';

import RegistrationStore from 'onboarding/stores/RegistrationStore';
import AuthCard from 'ui-brand/components/AuthCard';
import Button from 'ui-brand/components/Button';
import ProductSelection from 'ui-brand/components/ProductSelection';

type Props = {
  store: RegistrationStore;
  onSubmit: () => void;
  isSubmitting: boolean;
};

function ProductsStep({ store, onSubmit, isSubmitting }: Props) {
  return (
    <AuthCard
      wide
      eyebrow={interpolate(gettext('Step %(step)s of 3'), { step: 3 }, true)}
      title={gettext('What can we help you with?')}
      subtitle={gettext('Choose the product you want to start with.')}
    >
      <form
        className="mt-8"
        data-track-label="signup_form"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <ProductSelection
          disabled={isSubmitting}
          value={store.data.selected_products}
          onChange={(value) => store.updateData({ selected_products: value })}
        />
        <div className="mx-auto mt-8 flex max-w-[456px] flex-col items-center gap-4">
          <Button
            type="submit"
            variant="primary"
            size="lg"
            fullWidth
            arrow
            disabled={store.data.selected_products.length === 0}
            loading={isSubmitting}
          >
            {gettext("Let's go")}
          </Button>
          <Button variant="secondary" size="sm" onClick={store.goBack} disabled={isSubmitting}>
            {gettext('Back')}
          </Button>
        </div>
      </form>
    </AuthCard>
  );
}

export default observer(ProductsStep);
